const _ = require('lodash');

import { TreeNode } from './tree-node.model';
import { TreeService } from '../services/tree.service';

// TODO - Replace with something more generic
const defaultContextMenuActionMapping = {
    'Menu Link 1': (tree: TreeService, node: TreeNode) => { alert('Menu Link 1'); },
    'Menu Link 2': (tree: TreeService, node: TreeNode) => { alert('Menu Link 2'); },
    'Menu Link 3': (tree: TreeService, node: TreeNode) => { alert('Menu Link 3'); }
};

// TODO - Replace with something more generic
const defaultMenuLinksMapping = {
    'ORG': [
        { title: 'Menu Link 1' },
        { title: 'Menu Link 2' },
        { title: 'Menu Link 3' }
    ],
    'VDC': [
        { title: 'Menu Link 4' },
        { title: 'Menu Link 5' },
        { title: 'Menu Link 6' }
    ]
};


export class TreeOptions {
    childrenField: string = 'children';
    displayField: string = 'name';
    idField: string = 'id';
    treeNodeTemplate: any = '';
    loaderComponent: any = 'Loading...';
    getChildren: any;
    getIconClass;
    hasContextMenu: boolean;
    isExpandedField: string;
    contextMenuActionMapping: any;
    menuLinksMapping: any;
    typeField: string;
    leafTypes: string[];
    limitChildCount: number;
    hideSystemFolders: boolean;

    constructor(options: any = {}) {
        const optionsWithDefaults = _.defaultsDeep({}, options, {
            childrenField: 'children',
            displayField: 'name',
            idField: 'id',
            treeNodeTemplate: '',
            loaderComponent: 'Loading...',
            getChildren: undefined,
            getIconClass: undefined,
            hasContextMenu: false,
            isExpandedField: 'isExpanded',
            contextMenuActionMapping: defaultContextMenuActionMapping,
            menuLinksMapping: defaultMenuLinksMapping,
            typeField: 'entityType',
            leafTypes: [],
            limitChildCount: null,
            hideSystemFolders: false
        });
        _.extend(this, optionsWithDefaults);

    }
}



// WEBPACK FOOTER //
// ./src/common/tree/models/tree-options.model.ts